import {RestLink} from 'apollo-link-rest';

const restLink = new RestLink({
  uri: process.env.REACT_APP_REST_URL,
});

export default restLink;
